import { RootState } from '..';

export const selectors = {
	email: {
		get: (state: RootState) => state.templates.email,
		getInit: (state: RootState) => state.templates.email.init,
		getTemplates: (state: RootState) => state.templates.email.templates
	},
	getSourceEmailTemplate: (state: RootState) =>
		state.templates.sourceEmailTemplate,
	getSourceEmailTemplateLoaded: (state: RootState) =>
		state.templates.sourceEmailTemplateLoaded,
	getTargetEmailTemplateEnvironment: (state: RootState) =>
		state.templates.targetEmailTemplateEnvironment,
	targetEmailTemplate: {
		get: (state: RootState) => state.templates.targetEmailTemplate,
		getLoaded: (state: RootState) =>
			state.templates.targetEmailTemplate.loaded,
		getData: (state: RootState) => state.templates.targetEmailTemplate.data
	},
	getReplicateEmailTemplateStatus: (state: RootState) =>
		state.templates.replicateEmailTemplateStatus
};
